import moment from "moment"
import GenerateCondit, { Bound, IGnerCondit } from "."
import { getData } from "@/components/report/service"
import { Aggregator } from "./Interrelated"
import RouteEntity from "@/Entity/RouteEntity"
import BigNumber from 'bignumber.js'
import { Result } from "@/Entity/Tools/Result"

// type T = RouteEntity
export default class PublicAggCaculate extends GenerateCondit<RouteEntity>  {
  constructor(gc: IGnerCondit) {
    super(gc)
  }

  /**
   * @param unload_enity 卸车条件
   * @param pushForwaDay  库存起始时间增减@_1,moment().add(_1)
   * @returns 库存货量
   */
  async getStockData(enity: RouteEntity, pushForwaDay: moment.DurationInputArg1) {
    if (pushForwaDay)
      this.startDateAdd(pushForwaDay)

    enity.scanType = '分拨卸车'
    const unloadQuery = this.converCondit(enity)

    const groupByField = [...this.dimensions]
    const aggreField = this.aggregators.map((aggf: Aggregator) => aggf.fieldName)

    //#region  装车条件,会修改查询原型链
    const nextSiteIdx = this.dimensions.indexOf('nextSite')
    if (nextSiteIdx !== -1) {
      this.dimensions.splice(nextSiteIdx, 1, 'planNextSite')
    }
    enity.scanType = '分拨装车'
    enity.planNextSite = enity.nextSite
    enity.nextSite = null

    const nextSiteIdxNew = this.dimensions.indexOf('nextSiteCode')
    if (nextSiteIdxNew !== -1) {
      this.dimensions.splice(nextSiteIdxNew, 1, 'planNextSiteCode')
    }
    enity.planNextSiteCode = enity.nextSiteCode
    enity.nextSiteCode = null
    const bound = new Bound(
      'unloadAggregateTime',
      moment(this.startDate).format('YYYY-MM-DD'),
      moment(this.endDate).format('YYYY-MM-DD'),
    )
    this.boundFilters.push(bound)
    const loadQuery = this.converCondit(enity)
    //#endregion

    const unload = await getData(unloadQuery)
    const load = await getData(loadQuery)
    let data = this.calculateSotckData(unload, load, groupByField, aggreField)

    return data
  }

  /**
  * 会带入卸车的任务号(自动添加任务号分组),查询装车,但是可以被装车条件覆盖
  * @param unload_enity 卸车条件
  * @param load_enity 装车条件
  * @param pushForwaDay  库存起始时间增减@_1,moment().add(_1)
  * @returns 库存货量
  */
  async getStockDataWaybill(unload_enity: RouteEntity, load_enity: RouteEntity, pushForwaDay: moment.DurationInputArg1) {
    if (pushForwaDay)
      this.startDateAdd(pushForwaDay)

    const waybillNo = this.dimensions.indexOf('waybillNo')
    if (waybillNo === -1)
      this.dimensions.push('waybillNo')

    const groupByField = this.dimensions
    const aggreField = this.aggregators.map((aggf: Aggregator) => aggf.fieldName)

    /****卸车查询 */
    unload_enity.scanType = '分拨卸车'
    const unloadQuery = this.converCondit(unload_enity)
    const unload = await getData(unloadQuery)

    /****装车条件 */
    const unload_waybillNos = unload.map(m => m.waybillNo)
    const nextSiteIdx = this.dimensions.indexOf('nextSite')
    this.dimensions.splice(nextSiteIdx, 1, 'planNextSite')
    load_enity.scanType = '分拨装车'
    const bound = new Bound(
      'unloadAggregateTime',
      moment(this.startDate).format('YYYY-MM-DD'),
      moment(this.endDate).format('YYYY-MM-DD'),
    )
    this.boundFilters.push(bound)
    const loadQuery = this.converCondit({
      waybillNo: unload_waybillNos, ...load_enity
    })
    const load = await getData(loadQuery)
    //#endregion

    let data = this.calculateSotckData(unload, load, groupByField, aggreField)

    return data
  }

  /**
   *
   *  封装库存逻辑
   * @param unload 卸车数据
   * @param load 装车数据
   * @param groupByField 分组字段
   * @param aggreField 聚合字段
   * @returns 库存
   */
  calculateSotckData(
    unload: any, load: any,
    groupByField: string[], aggreField: string[],
    condit?: Result<any, boolean>
  ) {

    const result = []
    unload.forEach((item: RouteEntity) => {
      // 找到分组依据完全匹配的装车项
      const loadfind = load.find((m: RouteEntity) => {
        m.nextSite = m.planNextSite
        let finds = groupByField.length > 0
        groupByField.filter(field => {
          finds = finds && (m[field] === item[field])
          return !finds
        })
        return finds
      })

      // 拼接分组字段，卸车为准
      const temp = {}
      groupByField.forEach(gbfield => {
        temp[gbfield] = item[gbfield]
      })
      aggreField.forEach(aggField => {
        temp[aggField] = item[aggField]
      })

      // 卸车+装车库存
      if (loadfind) {
        aggreField.forEach(aggField => {
          const value = Number.parseFloat(new BigNumber(item[aggField]).plus(loadfind[aggField]).toString())
          temp[aggField] = value
        })
        if (!condit || condit(temp)) {
          result.push(temp)
        }
      }
    })
    return result
  }
}
